import { Skeleton } from '../../../components/Skeleton';
import styles from './SettingsSkeleton.module.scss';

export interface SettingsSkeletonProps {
  className?: string;
}

interface SkeletonSectionConfig {
  itemCount: number;
}

const sections: SkeletonSectionConfig[] = [
  { itemCount: 2 }, // Link Accounts / Account
  { itemCount: 4 }, // Preferences
  { itemCount: 2 }, // Privacy
  { itemCount: 2 }, // Security
  { itemCount: 1 }, // Save
];

export function SettingsSkeleton({ className }: SettingsSkeletonProps) {
  const classes = [styles.settingsSkeleton, className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className={styles.section}>
          {/* Section title placeholder */}
          <div className={styles.sectionTitle} aria-hidden="true">
            <Skeleton width="150px" height="1.5rem" borderRadius="4px" />
          </div>

          {/* Setting item rows */}
          {Array.from({ length: section.itemCount }, (_, itemIndex) => (
            <div key={itemIndex} className={styles.settingItem} aria-hidden="true">
              <Skeleton width="100px" height="1rem" borderRadius="4px" />
              <Skeleton width="150px" height="2rem" borderRadius="4px" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default SettingsSkeleton;
